const categoryMap = {
	'MetricRegression': 'RegressionMetric',
	'MetricDerived': 'DerivedMetric',
	'Metric': 'Metric',
	'FilterPeerGroup': 'FilterPeerGroupDocument',
	'Parameter': 'Parameter',
	'MetricGroup': 'MetricGroupDocument',
	'Process': 'Process',
	'Record': 'RecordDocument',
	'DataSource': 'DataSource',
	'DataSourceTable': 'DataSourceTable',
	'MetricOlap': 'OlapMetric',
	'View': 'ViewComponent',
	'SwimlaneGroup': 'SwimlaneGroup',
	'ProcessFilterDefinition': 'ProcessFilterDefinition',
	'RFunction': 'RFunction',
	'RModel': 'RModel',
	'Constant': 'ConstantDocument',
	'ExecutionPlan': 'ExecutionPlan',
	'Report': 'ReportSchedule',
	'WebService': 'WebServiceDocument',
	'TranslationTable': 'TranslationTable',
	'TitleColors': 'TitleColorList',
	'DatabaseServer': 'DatabaseServer',
	'Tenant': 'Tenant',
	'MetricAlert': 'MetricAlertDocument',
	'ProcessAlert': 'ProcessAlertDocument',
	'RecordAlert': 'RecordAlertDocument',
	'TestCase': 'TestCase',
	'TestGroup': 'TestGroup',
	'MetricPool': 'MetricPool',
	'MetricStandard': 'StandardMetric',
	'MetricProcess': 'ProcessMetric',
	'GeoDatabase': 'GeoDatabaseDocument',
	'TestDocument': 'TestDocument',
	'ExcludeFromCacheTestDocument': 'ExcludeFromCacheTestDocument',
	'OlapMetricDocument': 'OlapDocument',
	'FileProviderBatch': 'BatchDS',
	'FileProviderTemplate': 'ParsingTemplateDS',
	'FileProviderDownloaderServer': 'ServerDS',
	'FileProviderDownloaderTask': 'TaskDS',
	'SolutionConfigDocument': 'SolutionConfiguration',
	'GriverGroup': 'DriverGroup',
};
export default categoryMap;
